import React from 'react';

const PageHeader: React.FC = () => (
  <header className="border-b border-slate-200 pb-8 -mx-6 md:-mx-12 lg:-mx-16 px-6 md:px-12 lg:px-16">
    <p className="text-xs font-semibold uppercase tracking-[0.35em] text-slate-400">MajorBuddy</p>
    <h1 className="mt-3 text-4xl font-serif font-semibold text-slate-900">Fresh page. Clear plan.</h1>
    <p className="mt-4 max-w-2xl text-lg text-slate-600">
      Like the first sheet of a LaTeX document, this space stays crisp and uncluttered. 
      Tell us how your school structures the
      year so we can pace your journey.
    </p>
  </header>
);

export default PageHeader;
